// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wWan","col":"styles_col__2MTKo"};